import { render, staticRenderFns } from "./MessagesTemplateList.vue?vue&type=template&id=576859fa&"
import script from "./MessagesTemplateList.vue?vue&type=script&lang=js&"
export * from "./MessagesTemplateList.vue?vue&type=script&lang=js&"
import style0 from "./MessagesTemplateList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports